import { createInjectionKey as o } from "./ghl-ui.es896.js";
const c = o("n-color-picker");
export {
  c as colorPickerInjectionKey
};
